export default {
  en: {
    instructions: require('./instructions.json')
  }
}